@if (mapsKey$ | ngrxPush) {
  <div class="mapContainer"
    >
    <div class="map"
    [id]="renderIntoContainerId"></div>
  </div>
}